import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CallData {
  attendee_id: number;
  participant_group_id: number;
  requested_timestamp: string;
  status: string;
  connected_timestamp: string;
}

export interface TwilioAudioState {
  audioCallStatuses: Record<string, CallData>;
}

interface StartAudioCallPayload {
  session_id: string;
  session_uuid: string;
}

interface EndAudioCallPayload {
  participant_group_id?: number;
  session_id?: string;
  session_uuid?: string;
}

const initialState: TwilioAudioState = {
  audioCallStatuses: {},
};

const twilioAudioCall = createSlice({
  name: 'twilioAudio',
  initialState,
  reducers: {
    updateCallData: (state, { payload }: PayloadAction<any>) => {
      state.audioCallStatuses = payload;
      return state;
    },
    startAudioCall: (state, _action: PayloadAction<StartAudioCallPayload>) => state,
    endAudioCall: (state, _action: PayloadAction<EndAudioCallPayload>) => state,
  },
});

export const { startAudioCall, endAudioCall, updateCallData } = twilioAudioCall.actions;

export default twilioAudioCall.reducer;
